// RU-STRATSTATUS SS-1/SS-2: a strategy's current trading state, derived from its deployment document (or from the
// flat `strategy_*` fields a position / activity row carries). The one place that maps deployment -> state.

export const STATES = {
  running: "RUNNING",
  paused: "PAUSED",
  exits_only: "EXITS ONLY",
  not_deployed: "NOT DEPLOYED",
  retired: "RETIRED",
};

function normalise(src) {
  if ("strategy_mode" in src || "strategy_enabled" in src) {      // flat row (positions, autopilot activity)
    return {
      mode: src.strategy_mode, enabled: src.strategy_enabled, autopilot: src.strategy_autopilot,
      retired: src.strategy_retired === true, updated: src.strategy_updated_at,
    };
  }
  const dep = src.deployment || {};
  return {
    mode: dep.mode, enabled: dep.enabled, autopilot: dep.autopilot,
    retired: src.qualification?.status === "retired", updated: src.updated_at,
  };
}

export function strategyStatus(src, { openPosition = false } = {}) {
  if (!src || typeof src !== "object") return null;
  const n = normalise(src);
  const mode = n.mode === "paper" || n.mode === "live" ? n.mode : null;
  const enabled = n.enabled === true;
  let state;
  if (n.retired) state = "retired";
  else if (!mode) state = "not_deployed";
  else if (enabled) state = "running";
  else if (mode === "paper" && openPosition) state = "exits_only";
  else state = "paused";
  const autopilot = n.autopilot === true && state !== "not_deployed";

  const parts = [
    `Mode: ${mode === "live" ? "LIVE (real money)" : mode === "paper" ? "PAPER" : "not deployed"}`,
    `Enabled: ${mode ? (enabled ? "yes" : "no") : "—"}`,
    `Autopilot: ${autopilot ? "on" : "off"}`,
  ];
  if (state === "exits_only") parts.push("Paused: no new entries; open paper position exits keep running");
  if (state === "retired") parts.push("Retired (superseded by a newer version)");
  if (n.updated) parts.push(`Last updated: ${n.updated}`);
  return { mode, state, label: STATES[state], autopilot, enabled, title: parts.join(" · ") };
}
